import moment from "moment";

export function isInvoiceOverdue(invoice) {
  const remaining = Number(invoice?.amount_due ?? invoice?.amountDue ?? 0);
  if (remaining <= 0.009) return false;

  const dueDate = invoice?.due_date || invoice?.dueDate;
  if (!dueDate) return false;

  const due = moment(dueDate).startOf("day");
  if (!due.isValid()) return false;

  return due.isBefore(moment().startOf("day"));
}

export function resolveOverdueDisplay(invoice) {
  if (!isInvoiceOverdue(invoice)) {
    return { isOverdue: false, label: "—" };
  }

  const due = moment(invoice?.due_date || invoice?.dueDate).startOf("day");
  const daysOverdue = Math.max(moment().startOf("day").diff(due, "days"), 1);
  const label = daysOverdue === 1 ? "1 day" : `${daysOverdue} days`;

  return { isOverdue: true, label };
}

export function mapOverdueToAwaitingPayment(status) {
  return status === "overdue" ? "awaiting_payment" : status;
}
